import { usePointStore, usePolygonStore } from '@monopolio-ui/state-library'
import { MdOutlineHomeWork } from 'react-icons/md'
import Toggle from '../../Toggle'

const PropertiesToggleSelector = (): JSX.Element => {
  const { isEnablePropertiesPoints, setIsEnablePropertiesPoints } =
    usePointStore()

  const { isEnabledHeatMap } = usePolygonStore()

  const onClick = (): void => {
    setIsEnablePropertiesPoints(!isEnablePropertiesPoints)
  }

  if (!isEnabledHeatMap) {
    return <></>
  }

  return (
    <div
      className={`${[
        'py-1.5 pr-1.5 pl-3 flex items-center gap-1 rounded-full duration-150 bg-white animation-appear-03',
      ].join(' ')}`}
    >
      <MdOutlineHomeWork className="text-black w-4 h-4" />
      <p className="text-body-bold-s duration-200 text-primary">
        Ver propiedades
      </p>
      <Toggle onClick={onClick} size="sm" toggled={isEnablePropertiesPoints} />
    </div>
  )
}

export default PropertiesToggleSelector
